/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
var initImageWithTextBannerSlider = function initImageWithTextBannerSlider() {
  if (window.Splide) {
    new window.Splide('[data-image-with-text-banner-container]', {
      type: 'loop',
      arrows: false,
      start: 0  // Garante início fixo pelo primeiro slide
    }).mount();
  }
};
window.Sections = window.Sections || {};
if (window.Sections.ImageWithTextBanner) {
  window.Sections.ImageWithTextBanner += 1;
} else {
  window.Sections.ImageWithTextBanner = 1;
  
  // Inicializar assim que o script carregar para maior velocidade
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageWithTextBannerSlider);
  } else {
    // Se DOM já estiver pronto, inicializar imediatamente
    initImageWithTextBannerSlider();
  }
}
})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

/******/ })()
;